import { Box, Center, Circle, Divider, Flex, FormControl, FormErrorMessage, FormLabel, Image, Input, ListItem, Select, SimpleGrid, Spacer, Stack, Text, UnorderedList, VStack, useBreakpointValue } from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import MiniSideBar from '../../components/mini-sidebar'
import SecondaryNav from '../../components/seconday-nav'
import SideBar from '../../components/sidebar'
import { COLORS } from "../../components/styles/colors";
import { useForm } from "react-hook-form";
import { Controller, useWatch } from "react-hook-form";


import GrayCard from '../../components/card'
import {
  BrowserRouter as Router,
  generatePath,
  Routes,
  Route,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { AddVitalData, FetchPatientDetails } from '../../middleware/services/messages'
import { P } from '@antv/g2plot'
import moment from 'moment'
import SimpleTable from "../../components/simple-table";

import VisibleSidebar from '../../components/visible-sidebar'
import PatientVisitsIndex from './patientvisits'
import PatientVitalsIndex from './patientvitals'
import MedicalHistory from './medicalhistory'
import SurgicalHistory from './surgicalhistory'
import FamilyHistory from './familyhistory'
import SocialHistory from './socialhistory'
import PhysicalExam from './physicalexam'
// import TreatmentPlan from './treatmentplan'
import DoctorAssessment from './doctorassessment'
import ReviewSystem from './reviewsystem'
import Allergies from './allergies'
import Vaccinations from './vaccinations'
import Investigations from './investigations'
import LabTests from './labtest'
import OverviewIndex from './overview'
import ChiefComplaint from './chiefcomplaint'
import HistoryOfPresentIllness from './historyofpresentillness'
import OrdersIndex from './orders'
import MobileSecondaryNav from '../../components/mobile-secondary-navbar'
import MedicationIndex from './medications'
import Imaging from './imaging'
import { PrimaryButton, PrimaryInput, Toaster } from '../../components'
import useLoader from '../../components/loader/loaderstates'
import { actionAccessMain, calculateAgeCommonFunc, getLoginID } from '../../auth'
import ModalRight from '../../components/modal-right'
import DoctorVitalsFormData from '../../components/vital-data-patient-profile/vital-data'
import { GetPatientHealthData } from '../../middleware/services/visits/patient-overview'
import { GetDoctorNotes, updateDoctorNotes } from '../../middleware/services/visits/patient-overview/updatedoctornotes'
import DoctorNotesIndex from './doctornotes'
import DischargeSummaryIPD from './ipddischargenotes'


const PatientProfileIndex = () => {


  const navigate = useNavigate();
  const addVitalData = useRef();


  const location = useLocation();
  const [activeSection, setActiveSection] = useState(null)
  const [backNavigate, setBackNavigate] = useState(null)
  const [patientId, setPatientId] = useState(null);
  const [doctorId, setDoctorId] = useState(getLoginID());
  const [patienData, setPatienData] = useState(null);
  const [screenType, setScreenType] = useState('web');
  const [mobileActive, setMobileActive] = useState(null)

  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const [actionAccessPatients, setActionAccessPatients] = useState(null);
  useEffect(() => {
    setActionAccessPatients(actionAccessMain(4))
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setScreenType('mobile');
      } else {
        setScreenType('web');
      }
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //   const [isProfileUpdate, setIsProfileUpdate] = useState(false);
  //   useEffect(() => {
  //     if(isProfileUpdate) {
  //       fetchpatientdata(patientId)
  //       setIsProfileUpdate(false)
  //     }
  //   }, [isProfileUpdate])
  // console.log("PatientProfile index: ", isProfileUpdate)



  const dataTable = {
    "White blood cells": "",
    Hemoglobin: "",
    Hematocrit: "",
    "Platelet count": "",
    Chloride: "",
    Sodium: "",
    Potassium: "",
    CO2: "",
    BUN: "",
    Creatinine: "",
    Glucose: "",
  };

  const dataEntries = Object.entries(dataTable);


  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMM, YYYY");
  };
  const formatTime = (time) => {
    if (!time) {
      return "";
    }

    const [hours, minutes] = time.split(':');

    const date = new Date();
    date.setHours(hours, minutes);

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return formattedTime;
  };


  const navItems = [
    {
      to: "overview",
      iconSrc: "/assets/imgs/overview.png",
      text: "Overview",
    },
    {
      to: "visits",
      iconSrc: "/assets/imgs/visit.png",
      text: "Visits",
    },
    {
      to: "chiefComplaint",
      iconSrc: "/assets/imgs/cheif-complaint.png",
      text: "Chief Complaint",
    },
    {
      to: "historyOfPresentIllness",
      iconSrc: "/assets/svgs/coronavirus.svg",
      text: "History of Present Illness",
    },
    {
      to: "orders",
      iconSrc: "/assets/svgs/clinical_notes.svg",
      text: "Orders",
    },
    {
      to: "medications",
      iconSrc: "/assets/svgs/clinical_notes.svg",
      text: "Medications",
    },
    {
      to: "doctornotes",
      iconSrc: "/assets/svgs/clinical_notes.svg",
      text: "Doctor Notes",
    },
    {
      to: "vitals",
      iconSrc: "/assets/imgs/heart.png",
      text: "Vitals",
    },
    {
      to: "medicalHistory",
      iconSrc: "/assets/imgs/medical-history.png",
      text: "Medical history",
    },
    {
      to: "surgicalHistory",
      iconSrc: "/assets/imgs/surgeries.png",
      text: "Surgical history",
    },
    {
      to: "familyHistory",
      iconSrc: "/assets/imgs/family-history.png",
      text: "Family history",
    },
    {
      to: "socialHistory",
      iconSrc: "/assets/imgs/social-history.png",
      text: "Social history",
    },
    {
      to: "physicalExam",
      iconSrc: "/assets/imgs/physical-exam.png",
      text: "Physical exam",
    },
    // {
    //   to: "treatmentPlan",
    //   iconSrc: "/assets/imgs/treatment-plan.png",
    //   text: "Treatment plan",
    // },
    {
      to: "doctorAssessment",
      iconSrc: "/assets/imgs/treatment-plan.png",
      text: "Doctor Assessment",
    },
    {
      to: "reviewSystem",
      iconSrc: "/assets/imgs/protection.png",
      text: "Review of systems",
    },
    {
      to: "allergies",
      iconSrc: "/assets/imgs/allergy.png",
      text: "Allergies",
    },
    {
      to: "vaccinations",
      iconSrc: "/assets/imgs/syringe.png",
      text: "Vaccinations",
    },
    {
      to: "investigations",
      iconSrc: "/assets/imgs/investigation.png",
      text: "Investigations",
    },
    {
      to: "labTest",
      iconSrc: "/assets/imgs/biotech.png",
      text: "Lab tests",
    },
    {
      to: "imaging",
      iconSrc: "/assets/imgs/hand_bones.png",
      text: "Imaging",
    },
  ];

const ipdNavItems = [
    {
      to: "overview",
      iconSrc: "/assets/imgs/overview.png",
      text: "Overview",
    },
    {
      to: "chiefComplaint",
      iconSrc: "/assets/imgs/cheif-complaint.png",
      text: "Chief Complaint",
    },
    {
      to: "historyOfPresentIllness",
      iconSrc: "/assets/svgs/coronavirus.svg",
      text: "History of Present Illness",
    },
    {
      to: "physicalExam",
      iconSrc: "/assets/imgs/physical-exam.png",
      text: "Physical Exam",
    },
    {
      to: "doctorAssessment",
      iconSrc: "/assets/imgs/treatment-plan.png",
      text: "Doctor Assessment",
    },
    {
      to: "reviewSystem",
      iconSrc: "/assets/imgs/protection.png",
      text: "Review of Systems",
    },
    {
      to: "vitals",
      iconSrc: "/assets/imgs/heart.png",
      text: "Vitals",
    },
    {
      to: "medications",
      iconSrc: "/assets/svgs/clinical_notes.svg",
      text: "Medications",
    },
    {
      to: "labTest",
      iconSrc: "/assets/imgs/biotech.png",
      text: "Lab Tests",
    },
    {
      to: "imaging",
      iconSrc: "/assets/imgs/hand_bones.png",
      text: "Imaging",
    },
    {
      to: "doctornotes",
      iconSrc: "/assets/svgs/clinical_notes.svg",
      text: "Doctor Notes",
    },
    {
      to: "dischargeSummary",
      iconSrc: "/assets/svgs/clinical_notes.svg",
      text: "Discharge Summary Notes",
    },
    {
      text: "divider",
    },
    {
        to: "visits",
        iconSrc: "/assets/imgs/visit.png",
        text: "Visits",
      },
    {
      to: "medicalHistory",
      iconSrc: "/assets/imgs/medical-history.png",
      text: "Past Medical History",
    },
    {
      to: "surgicalHistory",
      iconSrc: "/assets/imgs/surgeries.png",
      text: "Surgical History",
    },
    {
      to: "familyHistory",
      iconSrc: "/assets/imgs/family-history.png",
      text: "Family History",
    },
    {
      to: "socialHistory",
      iconSrc: "/assets/imgs/social-history.png",
      text: "Social History",
    },
    {
      to: "allergies",
      iconSrc: "/assets/imgs/allergy.png",
      text: "Allergies",
    },
    {
      to: "vaccinations",
      iconSrc: "/assets/imgs/syringe.png",
      text: "Vaccinations",
    },
    {
      to: "orders",
      iconSrc: "/assets/svgs/clinical_notes.svg",
      text: "Orders",
    }
  ];
  const renderComponent = (sectionId) => {
    // console.log('sectionID: ', sectionId)
    const tableContainer = document.querySelector(".renderContainer");
    tableContainer.scrollTop = 0;
    setActiveSection(sectionId)
  }

  const [apptmtId, setApptmtId] = useState("");


  useEffect(() => {
    const currentUrl = window.location.href
    const searchParams = new URLSearchParams(currentUrl.split('?')[1]);
    const id = searchParams.get('id');
    const aptmtid = searchParams.get('appointmentid');
    const pageUrl = searchParams.get('page');

    setPatientId(id);
    setApptmtId(aptmtid)

    console.log('aptment ID: ', aptmtid)
    if (screenType == 'web') {
      setActiveSection(pageUrl)
    }
    if (aptmtid) {
      fetchpatientdata(id, aptmtid)
    } else {
      fetchpatientdata(id, "")
    }
    localStorage.setItem("patientid", id)
  }, []);

  // const [patientCountryId, setPatientCountryId] = useState(null);
  const fetchpatientdata = async (id, apmtid = "") => {
    setPatienData(null)
    try {
      const result = await FetchPatientDetails({
        patientid: id,
        ...(apmtid && { appointmentid: apmtid }), // Only include appointmentid if apmtid exists
        ...(apmtid && { type: 'ipd' })
      });
      console.log(result, "ressssssssss")
      if (result && result.patientinfo && result.patientinfo.countryid) {
        localStorage.setItem('patientCountryId', result.patientinfo.countryid)
        // setPatientCountryId(result.patientinfo.countryid)
      }

      if (result != null) {
        setPatienData(result);
      } else {
        setPatienData(null)
      }
      return result; // Add this line to return the data
    } catch (error) {
      console.error("Error in home:", error);
    }
  };

  // console.log(patientId, "IDDD")
  // console.log(patienData, "DAAAAAAA")


  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

    const formattedTime = hours + ':' + formattedMinutes + ' ' + ampm;
    return formattedTime;
  };


  const formatDateAndTime = (dateTimeString) => {
    const date = new Date(dateTimeString);

    const formattedTime = formatDateTime(dateTimeString);
    return ` ${formattedTime}`;
  };

  const backFunction = () => {
    setActiveSection(null); // Ensure the section resets
    navigate('/patientprofile?id=' + patientId);
  };

  const GenericUpload = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    const allFiles = e.target.files;
    console.log(allFiles, "allFiles from index")
    const fileCount = allFiles.length || 0;
    if (fileCount > 0) {

      localStorage.setItem("totalDocumentsSelected", fileCount);
      localStorage.setItem("remainingDocuments", fileCount);
    } else {
      localStorage.removeItem("remainingDocuments");
      localStorage.removeItem("totalDocumentsSelected");
    }

    showLoader();
    navigate("/docupload", { state: { file, allFiles } });
    dismissLoader();
  };


  const navigateBack = () => {
    let previousPage = localStorage.getItem("previousPage");
    if (previousPage) {
      navigate(`/${previousPage}`);
    } else {
      navigate("/patients");
    }
  };

  // ----------------------------- Add Vitals Functionality Starts ----------------------------
  const [patientHealthData, setPatientHealthData] = useState(null);

  const [tempUnit, setTempUnit] = useState("°F"
  );
  const [tempValue, setTempValue] = useState(""
  );
  const [error, setError] = useState("");
            // Temperature ranges in both units
    const MIN_TEMP_F = 89;
    const MAX_TEMP_F = 111;
    const MIN_TEMP_C = 31.7; // (89°F - 32) * 5/9 ≈ 31.7°C
    const MAX_TEMP_C = 43.9; // (111°F - 32) * 5/9 ≈ 43.9°C

  const [weightUnit, setWeightUnit] = useState('Standard'); // or 'Metric'
  const [heightUnit, setHeightUnit] = useState('Standard');

  // const [weightUnit, setWeightUnit] = useState( "lbs"
  // );
  const [weightValue, setWeightValue] = useState(""
  );
  // const [heightUnit, setHeightUnit] = useState("ft"
  // );
  const [heightValue, setHeightValue] = useState(""
  );
  const [heightSubValue, setHeightSubValue] = useState(""
  );

  const [bodyTemp, setBodyTemp] = useState('')
  const [heartRate, setHeartRate] = useState('')
  const [respRate, setRespRate] = useState('')
  const [systolic, setSystolic] = useState('')
  const [distolic, setDistolic] = useState('')
  const [spo2, setSpo2] = useState('')
  const [fastingBloodGlucose, setFastingBloodGlucose] = useState('')
  const [postBloodGlucose, setPostBloodGlucose] = useState('')

  // const handleChangeBodyTemperature = (event) => {
  //   let inputValue = event.target.value;
  //   // inputValue = inputValue.replace(/[^A-Za-z0-9\s@.]/g, '').slice(0, 50);
  //   inputValue = inputValue.replace(/[^0-9.]/g, '').slice(0, 50);
  //   event.target.value = inputValue;
  //   setTempValue(event.target.value);
  // };

  const validateTemperature = (value, unit) => {
    const numericValue = parseFloat(value);
    
    if (isNaN(numericValue)) {
      return "Please enter a valid number";
    }
    
    if (unit === "°F") {
      if (numericValue < MIN_TEMP_F || numericValue > MAX_TEMP_F) {
        return `Temperature must be between ${MIN_TEMP_F}°F and ${MAX_TEMP_F}°F`;
      }
    } else {
      if (numericValue < MIN_TEMP_C || numericValue > MAX_TEMP_C) {
        return `Temperature must be between ${MIN_TEMP_C.toFixed(1)}°C and ${MAX_TEMP_C.toFixed(1)}°C`;
      }
    }
    
    return "";
  };

  const handleChangeBodyTemperature = (event) => {
    let inputValue = event.target.value;
    
    // Allow empty value
    if (inputValue === "") {
      setTempValue("");
      setError("");
      return;
    }
    
    // Allow only one decimal point and numbers
    inputValue = inputValue.replace(/[^0-9.]/g, '');
    
    // Prevent multiple decimals
    const parts = inputValue.split('.');
    if (parts.length > 2) {
      inputValue = parts[0] + '.' + parts.slice(1).join('');
    }

    // Set the value first, then validate
    setTempValue(inputValue);
    
    // Validate if input is not empty
    if (inputValue !== '') {
      const validationError = validateTemperature(inputValue, tempUnit);
      setError(validationError);
      
      // if (validationError) {
      //   showErrorToast(validationError);
      // }
    } else {
      setError("");
    }
  };

//   const handleChangeBodyTemperature = (event) => {
//   let inputValue = event.target.value;
//   // Allow only one decimal point and numbers
//   inputValue = inputValue.replace(/[^0-9.]/g, '');
//   // Prevent multiple decimals
//   const parts = inputValue.split('.');
//   if (parts.length > 2) {
//     inputValue = parts[0] + '.' + parts.slice(1).join('');
//   }
//   setTempValue(inputValue);
// };
  const handleChangeHeartRate = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setHeartRate(event.target.value);
  };
  const handleChangeRespiratoryRate = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setRespRate(event.target.value);
  };
  const handleChangeSystolic = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setSystolic(event.target.value);
  };
  const handleChangeDistolic = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setDistolic(event.target.value);
  };
  const handleSP02 = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setSpo2(event.target.value);
  };
  const handleFastingBloodGlucose = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setFastingBloodGlucose(event.target.value);
  };
  const handlePostBloodGlucose = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^0-9]/g, '').slice(0, 50);
    event.target.value = inputValue;
    setPostBloodGlucose(event.target.value);
  };

  const openVitalsModal = () => {
    setTempValue('')
    setHeartRate('')
    setSpo2('')
    setSystolic('')
    setDistolic('')
    setRespRate('')
    setFastingBloodGlucose('')
    setPostBloodGlucose('')
    // setWeightValue('')
    // setHeightValue('')
    // setHeightSubValue('')

    // Prepopulate height and weight from patient data
    if (patienData.patientinfo?.weight) {
      setWeightValue(patienData.patientinfo.weight)
      setWeightUnit(patienData.patientinfo.weightunit === 'kg' ? 'Metric' : 'Standard')
    }

    if (patienData.patientinfo?.height) {
      // Handle both space-separated ("5 9") and decimal ("5.9") formats
      let feet = '';
      let inches = '';

      if (patienData.patientinfo.heightunit === 'cms') {
        // Metric height (single value in cm)
        setHeightValue(patienData.patientinfo.height)
        setHeightSubValue('')
        setHeightUnit('Metric')
      } else {
        // Standard height - check for both formats
        if (patienData.patientinfo.height.includes('.')) {
          // Decimal format (e.g., "6.0")
          [feet, inches] = patienData.patientinfo.height.split('.')
          // inches = inches === '0' ? '' : inches // Show empty if inches is 0
        } else if (patienData.patientinfo.height.includes(' ')) {
          // Space-separated format (e.g., "6 0")
          [feet, inches] = patienData.patientinfo.height.split(' ')
          // inches = inches === '0' ? '' : inches // Show empty if inches is 0
        } else {
          // Single value (assume feet only)
          feet = patienData.patientinfo.height
          inches = '0'
        }

        setHeightValue(feet)
        setHeightSubValue(inches)
        setHeightUnit('Standard')
      }
    }
    // existing
    // if (patienData.patientinfo?.height) {
    //   // Parse height string like "5 9" or "175 cm"
    //   const heightParts = patienData.patientinfo.height.split(' ')

    //   if (patienData.patientinfo.heightunit === 'cms') {
    //     // Metric height (single value in cm)
    //     setHeightValue(heightParts[0])
    //     setHeightSubValue('') // No sub value for metric
    //     setHeightUnit('Metric')
    //   } else {
    //     // Standard height (ft in)
    //     if (heightParts.length >= 2) {
    //       setHeightValue(heightParts[0]) // feet
    //       setHeightSubValue(heightParts[1]) // inches
    //     } else if (heightParts.length === 1) {
    //       setHeightValue(heightParts[0]) // feet only
    //       setHeightSubValue('0') // default 0 inches
    //     }
    //     setHeightUnit('Standard')
    //   }
    // }
    if (activeSection == 'vitals') {
      // renderComponent('visits')
      setActiveSection('vitals')
    }
    addVitalData.current.openRight();
  }

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  // const temperatureUnit = useWatch({ control, name: "temperatureUnit" });

  // const fetchDoctorNotes = async () => {
  //   const inputToFetch = {
  //     input: {
  //       patientid: patientId,
  //       doctorid: getLoginID(),
  //       // appointmentid: appointmentId,
  //     },
  //   };
  //   showLoader();
  //   try {
  //     const data = await GetDoctorNotes(inputToFetch.input);
  //     const vitals = data?.output?.data?.vitals || [];
  //     const formValues = {};
  //     vitals.forEach((vital) => {
  //       let vitalName = vital.vitalname;

  //       // Check and adjust vital names if needed
  //       if (vitalName === "Body temperature") {
  //         vitalName = "Body Temperature";
  //       } else if (vitalName === "Respiratory rate") {
  //         vitalName = "Respiratory Rate";
  //       }
  //       formValues[vitalName] = vital.vitalvalue;
  //     });
  //     const temperatureUnit =
  //       vitals.find(
  //         (vital) =>
  //           vital.vitalname === "Body temperature" ||
  //           vital.vitalname === "Body Temperature"
  //       )?.vitalunit || "°F";
  //     formValues["temperatureUnit"] = temperatureUnit;

  //     // Reset form with fetched values
  //     reset(formValues);

  //     // console.log("Fetched form values: ", formValues);
  //   } catch (error) {
  //     console.error("Error fetching Doctor Notes data:", error);
  //   } finally {
  //     dismissLoader();
  //   }
  // };

  // const onSubmit = async (data) => {
  //   console.log('data; ', data)
  //   const vitals = [];

  //   const fields = [
  //     { name: "Systolic Blood Pressure", unit: "mmHg" },
  //     { name: "Diastolic Blood Pressure", unit: "mmHg" },
  //     { name: "Pulse", unit: "bpm" },
  //     { name: "Body Temperature", unit: data.temperatureUnit },
  //     { name: "Respiratory Rate", unit: "bpm" },
  //     { name: "Oxygen Saturation", unit: "%" },
  //     { name: "Fasting Blood Glucose", unit: "mg/dL" },
  //     { name: "Postprandial Blood Glucose", unit: "mg/dL" },
  //   ];

  //   fields.forEach((field) => {
  //     const value = data[field.name];
  //     const padZero = (num) => num.toString().padStart(2, "0");

  //     const now = new Date();
  //     const formattedDate = `${now.getFullYear()}-${padZero(
  //       now.getMonth() + 1
  //     )}-${padZero(now.getDate())} ${padZero(now.getHours())}:${padZero(
  //       now.getMinutes()
  //     )}:${padZero(now.getSeconds())}`;

  //     if (value !== undefined && value !== "") {
  //       vitals.push({
  //         vitalname: field.name,
  //         vitalvalue: value,
  //         vitalunit: field.unit,
  //         vitaltype_cd: "",
  //         // vitaladdeddate: new Date().toISOString(),
  //         vitaladdeddate: formattedDate,
  //       });
  //     }
  //   });

  //   const inputToSave = {
  //     input: {
  //       doctorid: getLoginID(),
  //       patientid: patientId,
  //       // appointmentid: appointmentId,
  //       vitals: vitals,
  //     },
  //   };
  //   console.log(inputToSave);
  //   showLoader();
  //   try {
  //     // const result = await updateDoctorNotes(inputToSave.input);
  //     // if (result) {
  //     //   showSuccessToast("Vitals saved successfully");
  //     //   fetchDoctorNotesEmptyIndication();
  //     //   setIsButtonDisabled(true); // Disable button after successful submission
  //     // }
  //     if (inputToSave.input.vitals && inputToSave.input.vitals.length > 0) {
  //       const result = await AddVitalData(inputToSave.input);
  //       if (result) {
  //         showSuccessToast("Vitals saved successfully");
  //         // fetchDoctorNotesEmptyIndication();
  //         setIsButtonDisabled(true); // Disable button after successful submission
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error in saving vitals:", error);
  //     showErrorToast("Error happened while saving vitals.");
  //   } finally {
  //     dismissLoader();
  //   }
  // };

  // useEffect(() => {
  //   fetchDoctorNotes();
  // }, []);

  // useEffect(() => {
  //   setIsButtonDisabled(!isDirty);
  // }, [isDirty]);

  //BMI

  // const [weightUnit, setWeightUnit] = useState(
  //   currentWeightUnit ? currentWeightUnit : "lbs"
  // );
  // const [weightValue, setWeightValue] = useState(
  //   currentWeightValue ? currentWeightValue : ""
  // );
  // const [heightUnit, setHeightUnit] = useState(
  //   currentHeightUnit ? currentHeightUnit : "ft"
  // );
  // const [heightValue, setHeightValue] = useState(
  //   currentHeightValue ? currentHeightValue : ""
  // );
  // const [heightSubValue, setHeightSubValue] = useState(
  //   currentHeightSubValue ? currentHeightSubValue : ""
  // );

  const handleTempUnitChange = (newUnit) => {
    if (newUnit === tempUnit) return; // No change needed if same unit

    if (tempValue) {
      const numericValue = parseFloat(tempValue);
      
      if (newUnit === "°F") {
        // Convert from °C to °F: (°C × 9/5) + 32
        const convertedValue = (numericValue * 9/5) + 32;
        
        // Validate converted value
        if (convertedValue < MIN_TEMP_F || convertedValue > MAX_TEMP_F) {
          setError(`Converted temperature ${convertedValue.toFixed(1)}°F is outside valid range (${MIN_TEMP_F}°F - ${MAX_TEMP_F}°F)`);
          return; // Don't change unit if conversion results in invalid value
        }
        
        setTempValue(convertedValue.toFixed(1));
      } else {
        // Convert from °F to °C: (°F - 32) × 5/9
        const convertedValue = (numericValue - 32) * 5/9;
        
        // Validate converted value
        if (convertedValue < MIN_TEMP_C || convertedValue > MAX_TEMP_C) {
          setError(`Converted temperature ${convertedValue.toFixed(1)}°C is outside valid range (${MIN_TEMP_C.toFixed(1)}°C - ${MAX_TEMP_C.toFixed(1)}°C)`);
          return; // Don't change unit if conversion results in invalid value
        }
        
        setTempValue(convertedValue.toFixed(1));
      }
    }
    
    setTempUnit(newUnit);
    setError(""); // Clear error when changing unit
  };

  // const handleTempUnitChange = (newUnit) => {
  //   if (newUnit === "°F") {
  //     if (tempValue) {
  //       if (tempUnit === "°F")
  //         setTempValue((prev) => (prev * 2.20462).toFixed(2));
  //     }

  //     setTempUnit("°F");
  //   } else if (newUnit === "°C") {
  //     if (tempValue) {
  //       if (tempUnit === "°C") {
  //         setTempValue((prev) => (prev / 2.20462).toFixed(2));
  //       }
  //     }

  //     setTempUnit("°C");
  //   }
  // };

  const handleUnitChange = (newUnit) => {
    // Convert weight
    if (weightValue) {
      setWeightValue(prev => {
        const numValue = parseFloat(prev);
        if (newUnit === "Standard" && weightUnit === "Metric") {
          return (numValue * 2.20462).toFixed(2); // kg to lbs
        } else if (newUnit === "Metric" && weightUnit === "Standard") {
          return (numValue / 2.20462).toFixed(2); // lbs to kg
        }
        return prev;
      });
    }

    // Convert height
    if (heightValue) {
      if (newUnit === "Standard" && heightUnit === "Metric") {
        // cm to ft+in
        const totalInches = parseFloat(heightValue) / 2.54;
        const feet = Math.floor(totalInches / 12);
        const inches = Math.round(totalInches % 12);
        setHeightValue(feet.toString());
        setHeightSubValue(inches.toString());
      } else if (newUnit === "Metric" && heightUnit === "Standard") {
        // ft+in to cm
        const feet = parseFloat(heightValue) || 0;
        const inches = parseFloat(heightSubValue) || 0;
        const totalInches = (feet * 12) + inches;
        setHeightValue((totalInches * 2.54).toFixed(2));
        setHeightSubValue('');
      }
    }
    // if (heightValue) {
    //   if (newUnit === "Standard" && heightUnit === "Metric") {
    //     // cm to ft+in
    //     const totalInches = parseFloat(heightValue) / 2.54;
    //     setHeightValue(Math.floor(totalInches / 12));
    //     setHeightSubValue(Math.round(totalInches % 12));
    //   } else if (newUnit === "Metric" && heightUnit === "Standard") {
    //     // ft+in to cm
    //     const totalInches = (parseFloat(heightValue) * 12) + parseFloat(heightSubValue || 0);
    //     setHeightValue((totalInches * 2.54).toFixed(2));
    //     setHeightSubValue('');
    //   }
    // }

    // Update both units together
    setWeightUnit(newUnit);
    setHeightUnit(newUnit);
  };

  // const handleUnitChange = (newUnit) => {
  //   if (newUnit === "Standard") {
  //     if (weightValue) {
  //       if (weightUnit === "kg")
  //         setWeightValue((prev) => (prev * 2.20462).toFixed(2));
  //     }
  //     if (heightValue) {
  //       if (heightUnit === "cm") {
  //         setHeightValue(Math.floor(heightValue / 30.48));
  //         setHeightSubValue(Math.round((heightValue % 30.48) / 2.54));
  //       }
  //     }
  //     setWeightUnit("lbs");
  //     setHeightUnit("ft");
  //   } else if (newUnit === "Metric") {
  //     if (weightValue) {
  //       if (weightUnit === "lbs") {
  //         setWeightValue((prev) => (prev / 2.20462).toFixed(2));
  //       }
  //     }
  //     if (heightValue) {
  //       if (heightUnit === "ft") {
  //         const totalInches = heightValue * 12 + Number(heightSubValue);
  //         setHeightValue(Math.floor(totalInches * 2.54));
  //         setHeightSubValue(Math.round(((totalInches * 2.54) % 1) * 10));
  //       }
  //     }
  //     setWeightUnit("kg");
  //     setHeightUnit("cm");
  //   }
  // };

  // const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
  const [date, setDate] = useState(moment().format("yyyy-MM-DD"));
  const [time, setTime] = useState(moment().format("HH:mm"));

  const [refreshVitals, setRefreshVitals] = useState(false);
  const fetchVitalsRef = useRef();

  const SubmitBMIform = async () => {

    if (!validateHeightInputs()) {
      return;
    }

    // Temperature validation
  if (tempValue) {
    const numericTemp = parseFloat(tempValue);
    
    if (tempUnit === "°F") {
      if (numericTemp < 89 || numericTemp > 111) {
        showErrorToast("Please enter a proper temperature between 89°F and 111°F");
        return;
      }
    } else {
      // Convert Celsius limits: (89°F = 31.7°C, 111°F = 43.9°C)
      if (numericTemp < 31.7 || numericTemp > 43.9) {
        showErrorToast("Please enter a proper temperature between 31.7°C and 43.9°C");
        return;
      }
    }
  }

    // Convert the unit system to specific units before sending
    const weightUnitToSend = weightUnit === 'Standard' ? 'lbs' : 'kg';
    const heightUnitToSend = heightUnit === 'Standard' ? 'ft' : 'cms';

    // Handle height value properly
    // let formattedHeightValue = heightValue;
    // if (heightUnit === 'Standard') {
    //   // For Standard units (ft.in), ensure we don't have decimals in feet
    //   const feetValue = heightValue.includes('.') ? 
    //     Math.floor(parseFloat(heightValue)) : 
    //     (heightValue ? parseFloat(heightValue) : 0);
    //   const inchesValue = heightSubValue ? parseFloat(heightSubValue) : 0;

    //   formattedHeightValue = `${feetValue}.${inchesValue}`;
    // } else {
    //   // For Metric units, ensure it's a proper number
    //   formattedHeightValue = heightValue ? parseFloat(heightValue).toString() : '';
    // }
    let formattedHeightValue;
    if (heightUnit === 'Standard') {
      const feet = heightValue || '0';
      const inches = heightSubValue === '' ? '0' : heightSubValue;
      formattedHeightValue = `${feet}.${inches}`;
      // const feet = heightValue ? parseInt(heightValue) : 0;
      // const inches = heightSubValue ? parseInt(heightSubValue) : 0;
      // formattedHeightValue = `${feet}.${inches}`;
    } else {
      // formattedHeightValue = heightValue ? parseFloat(heightValue).toString() : '';
      formattedHeightValue = heightValue || '';
    }

    const inputToSave = {
      input: {
        doctorid: getLoginID(),
        ...(apptmtId && { appointment_id: apptmtId }),
        patientid: patientId,
        "vitals": [
          {
            vitalname: "Weight",
            vitalvalue: weightValue,
            vitalunit: weightUnitToSend,
            vitaltype_cd: "",
            vitaladdeddate: `${date} ${time}`,
          },
          {
            vitalname: "Height",
            // vitalvalue: (heightValue && heightSubValue) ? heightValue + "." + heightSubValue : heightValue,
            vitalvalue: formattedHeightValue,
            // vitalvalue: (heightValue && heightSubValue) ? heightValue + "." + heightSubValue : '',
            vitalunit: heightUnitToSend,
            vitaltype_cd: "238",
            vitaladdeddate: `${date} ${time}`,
          },
          {
            "vitalname": "Systolic Blood Pressure",
            "vitalvalue": systolic,
            "vitalunit": "mmHg",
            "vitaltype_cd": "",
            vitaladdeddate: `${date} ${time}`
          },
          {
            "vitalname": "Diastolic Blood Pressure",
            "vitalvalue": distolic,
            "vitalunit": "mmHg",
            "vitaltype_cd": "",
            vitaladdeddate: `${date} ${time}`
          },
          {
            "vitalname": "Pulse",
            "vitalvalue": heartRate,
            "vitalunit": "bpm",
            "vitaltype_cd": "",
            vitaladdeddate: `${date} ${time}`
          },
          {
            "vitalname": "Body Temperature",
            "vitalvalue": tempValue,
            "vitalunit": tempUnit,
            "vitaltype_cd": "",
            vitaladdeddate: `${date} ${time}`
          },
          {
            "vitalname": "Respiratory Rate",
            "vitalvalue": respRate,
            "vitalunit": "bpm",
            "vitaltype_cd": "",
            vitaladdeddate: `${date} ${time}`
          },
          {
            "vitalname": "Oxygen Saturation",
            "vitalvalue": spo2,
            "vitalunit": "%",
            "vitaltype_cd": "",
            vitaladdeddate: `${date} ${time}`
          },
          {
            "vitalname": "Fasting Blood Glucose",
            "vitalvalue": fastingBloodGlucose,
            "vitalunit": "mg/dL",
            "vitaltype_cd": "",
            vitaladdeddate: `${date} ${time}`
          },
          {
            "vitalname": "Postprandial Blood Glucose",
            "vitalvalue": postBloodGlucose,
            "vitalunit": "mg/dL",
            "vitaltype_cd": "",
            vitaladdeddate: `${date} ${time}`
          }
        ].filter((vital) => vital.vitalvalue !== ""),
      },
    };
    if (moment(date, "DD-MM-YYYY", true).isValid()) {
      const formatteddate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
      const vitaldate = formatteddate + " " + time;
    }
    showLoader();
    try {
      if (inputToSave.input.vitals && inputToSave.input.vitals.length > 0) {
        const result = await AddVitalData(inputToSave.input);
        if (result && result.output.message === "Successfully Inserted/Updated") {
          addVitalData.current.closeRight();
          renderComponent('vitals')
          fetchpatientdata(patientId)
          showSuccessToast("Vitals saved successfully");
          setIsButtonDisabled(true); // Disable button after successful submission
          // setRefreshVitals(prev => !prev);
          // Call the child's function
          if (fetchVitalsRef.current) {
            fetchVitalsRef.current(patientId, apptmtId);
          }

        }
        dismissLoader();
      }
      dismissLoader();

      // if (response.output.success == 1) {
      //   if (result.output.success == 1) {
      //     // dismissLoader();
      //   }
      // } else {
      //   showErrorToast("Error happened while saving demographics.");
      // }
    } catch (error) {
      console.error("Error in SubmitFunction:", error);
    }
  };
  // ----------------------------- Add Vitals Functionality Ends ----------------------------

  const [bmi, setBmi] = useState(null);

  // Function to calculate BMI
  const calculateBMI = (weight, height, heightSub, weightUnit, heightUnit) => {
    if (!weight || !height) {
      setBmi(0);
      return;
    }

    let weightInKg = weightUnit === "lbs" ? weight / 2.20462 : weight; // Convert lbs to kg
    let heightInMeters = 0;

    let bmiValue = 0;
    
      if (heightUnit === "Metric") {
        heightInMeters = height / 100; // Convert cm to meters
        bmiValue = weight / (heightInMeters * heightInMeters);
      } else {
        // Convert feet and inches to meters
        // let totalInches = height * 12 + Number(heightSub || 0);
        // heightInMeters = totalInches * 0.0254;
        let totalInches = (parseFloat(height) * 12) + (parseFloat(heightSub) || 0);
    bmiValue = (703 * weight) / (totalInches * totalInches);
      }
    
      setBmi(bmiValue > 0 ? bmiValue.toFixed(1) : 0);

    // if (heightUnit === "cms") {
    //   heightInMeters = height / 100; // Convert cm to meters
    // } else {
    //   // Convert feet and inches to meters
    //   let totalInches = height * 12 + Number(heightSub || 0);
    //   heightInMeters = totalInches * 0.0254;
    // }

    // if (heightInMeters > 0) {
    //   let bmiValue = weightInKg / (heightInMeters * heightInMeters);
    //   setBmi(bmiValue.toFixed(1));
    // } else {
    //   setBmi(0);
    // }
  };

  // Call BMI function when height or weight changes
  useEffect(() => {
    calculateBMI(weightValue, heightValue, heightSubValue, weightUnit, heightUnit);
  }, [weightValue, heightValue, heightSubValue, weightUnit, heightUnit]);

  const validateHeightInputs = () => {
    if (heightUnit === 'Standard') {
      // For Standard units, feet should be integer, inches between 0-11
      const feet = parseFloat(heightValue) || 0;
      const inches = parseFloat(heightSubValue) || 0;

      // if (isNaN(feet) || feet <= 0) {
      //   showErrorToast("Please enter valid feet value");
      //   return false;
      // }

      // if (!Number.isInteger(feet)) {
      //   showErrorToast("Feet must be a whole number");
      //   return false;
      // }

      // // Check if inches is entered (but allow empty display)
      // if (heightSubValue === '') {
      //   showErrorToast("Please enter inches value");
      //   return false;
      // }

      // if (isNaN(inches)) {
      //   showErrorToast("Please enter valid inches value");
      //   return false;
      // }

      // if (!Number.isInteger(inches)) {
      //   showErrorToast("Inches must be a whole number");
      //   return false;
      // }

      // if (inches < 0 || inches > 11) {
      //   showErrorToast("Inches must be between 0-11");
      //   return false;
      // }

      // Check if feet is valid
      if (isNaN(feet) || feet <= 0) {
        showErrorToast("Please enter valid feet value");
        return false;
      }

      // Check if feet is whole number
      if (!Number.isInteger(feet)) {
        showErrorToast("Feet must be a whole number");
        return false;
      }

      // Check if inches is entered (but allow empty display)
      if (heightSubValue === '') {
        showErrorToast("Please enter inches value");
        return false;
      }

      // Check if inches is valid (0-11)
      if (isNaN(inches) || inches < 0 || inches > 11) {
        showErrorToast("Inches must be between 0-11");
        return false;
      }

      // if (!Number.isInteger(feet)) {
      //   showErrorToast("Feet must be a whole number");
      //   return false;
      // }

      // if (inches < 0 || inches > 11) {
      //   showErrorToast("Inches must be between 0-11");
      //   return false;
      // }
    } else {
      // For Metric units, just check it's a valid number
      // For Metric units (cm)
      const cm = parseFloat(heightValue);
      if (isNaN(cm) || cm <= 0) {
        showErrorToast("Please enter a valid height in centimeters");
        return false;
      }
      // if (isNaN(parseFloat(heightValue))) {
      //   showErrorToast("Please enter a valid height");
      //   return false;
      // }
    }
    return true;
  };

  function redirectDischargeSummary() {
    const doctorId = getLoginID();
    if (apptmtId) {
      navigate(`/dischargesummary?patientId=${patientId}&doctId=${doctorId}&appointmentId=${apptmtId}&type=${"ipd"}`);
    } 
  }
  return (
    <>
      {screenType == 'web' ? (


        <Box w="100%">
          <Flex>
            <Box w="6rem">
              <MiniSideBar />
            </Box>
            <Box w="100%">
              <SecondaryNav customHeader={<>
                <Box as='button' display="flex" alignItems="center" gap="1rem">
                  <Image src="/assets/imgs/back-arrow.png"
                    onClick={navigateBack}
                  />
                  {apptmtId ? (
                    <Text fontSize="1.25rem" fontWeight="600">Patient IPD Progress Report</Text>
                  ) : (
                    <Text fontSize="1.25rem" fontWeight="600">Patient profile</Text>
                  )}
                </Box>
              </>} />
              {/* Main container start */}
              <Flex w="calc(100vw - 6rem)">
                <Box
                  // p="1.5rem 8.25rem"
                  display="flex"
                  // h="calc(100vh - 50px)"
                  // overflow="hidden auto"
                  w="100%"
                >

                  {/* Left area start */}
                  <Box w={{ lg: "13rem", xl: "16rem" }} h="calc(100vh - 75px)" overflow="hidden auto" borderRight="1px solid #E6E7E9">
                    <VisibleSidebar navItems={apptmtId ? ipdNavItems : navItems} activeSection={activeSection} onNavItemClick={renderComponent} isLogout={false} visibleSidebarStyle={{ minW: "unset", w: "100%" }} />
                  </Box>
                  {/* Left area end */}

                  {/* Main container start */}
                  <Box w={{ lg: "calc(100vw - 28rem)", xl: "calc(100vw - 36rem)" }} bg="#ffffff" overflow="hidden">
                    <Box flexDir="column" className='renderContainer'
                      p={activeSection == 'orders' || activeSection == 'vaccinations' || activeSection == "socialHistory" || activeSection == 'allergies' || activeSection == "labTest" || activeSection == "medicalHistory" || activeSection == "surgicalHistory" || activeSection == "medications" || activeSection == "doctornotes" || activeSection == "vitals" || activeSection == "familyHistory" || activeSection == "doctorAssessment" || activeSection == 'physicalExam' || activeSection == "dischargeSummary" || activeSection == "reviewSystem" || activeSection == "chiefComplaint" || activeSection == "historyOfPresentIllness" ? '0' : "1.5rem"} bg="#fcfcfd"

                      h={activeSection == 'vaccinations' || activeSection == 'allergies' || activeSection == "labTest" || activeSection == "vitals" || activeSection == "socialHistory" || activeSection == "medicalHistory" || activeSection == "surgicalHistory" || activeSection == "medications" || activeSection == "doctornotes" || activeSection == "familyHistory" || activeSection == "dischargeSummary" || activeSection == "reviewSystem" || activeSection == "chiefComplaint" || activeSection == "historyOfPresentIllness" ? '' : "calc(100vh - 75px)"} w="100%" overflow="hidden auto">
                      <Flex>

                        {activeSection == "overview" && (
                          <OverviewIndex pid={patientId} fetchParentData={fetchpatientdata} />
                        )}
                        {activeSection == "visits" && (
                          <PatientVisitsIndex id={patientId} />
                        )}

                        {activeSection == "chiefComplaint" && (
                          <ChiefComplaint id={patientId} doctorId={doctorId} appointmentId={apptmtId} />
                        )}

                        {activeSection == "historyOfPresentIllness" && (
                          <HistoryOfPresentIllness id={patientId} />
                        )}

                        {activeSection == "orders" && (
                          <OrdersIndex id={patientId} />
                        )}

                        {activeSection == "medications" && (
                          <MedicationIndex id={patientId} />
                        )}

                        {activeSection == "doctornotes" && (
                          <DoctorNotesIndex id={patientId} doctorId={doctorId} appointmentid={apptmtId} />
                        )}

                        {activeSection == "vitals" && (
                          <PatientVitalsIndex id={patientId}
                            registerFetchFunction={(fetchFn) => {
                              fetchVitalsRef.current = fetchFn;
                            }}
                          />
                        )}

                        {activeSection == "medicalHistory" && (
                          <MedicalHistory id={patientId} />
                        )}

                        {activeSection == "surgicalHistory" && (
                          <SurgicalHistory id={patientId} />
                        )}

                        {activeSection == "familyHistory" && (
                          <FamilyHistory id={patientId} />
                        )}

                        {activeSection == "socialHistory" && (
                          <SocialHistory id={patientId} />
                        )}

                        {activeSection == "physicalExam" && (
                          <PhysicalExam id={patientId} doctorId={doctorId} appointmentid={apptmtId} />
                        )}

                        {/* {activeSection == "treatmentPlan" && (
                          <TreatmentPlan id={patientId} />
                        )} */}
                        {activeSection == "doctorAssessment" && (
                          <DoctorAssessment id={patientId} doctorId={doctorId} appointmentid={apptmtId} />
                        )}

                        {activeSection == "reviewSystem" && (
                          <ReviewSystem id={patientId} />
                        )}
                        {activeSection == "dischargeSummary" && (
                          <DischargeSummaryIPD id={patientId} />
                        )}
                        {activeSection == "allergies" && (
                          <Allergies id={patientId} />
                        )}
                        {activeSection == "vaccinations" && (
                          <Vaccinations id={patientId} />
                        )}
                        {activeSection == "investigations" && (
                          <Investigations id={patientId} />
                        )}
                        {activeSection == "labTest" && (
                          <LabTests id={patientId} />
                        )}
                        {activeSection == "imaging" && (
                          <Imaging id={patientId} />
                        )}

                      </Flex>
                    </Box>
                  </Box>
                  {/* Main container end */}

                  {/* Right area start */}
                  {/* Recent Activity start */}


                  <Box w={{ lg: "15rem", xl: "20rem" }} borderLeft="1px solid #E6E7E9">
                    {
                      patienData && patienData.patientinfo && (

                        apptmtId ? (
                          <VStack p="1.5rem" align="stretch" gap="1rem" overflow="hidden auto" bg="#fcfcfd" h="100vh">
                            <Box>
                              <Box display="flex" flexDir="column" gap="0.65rem">
                                <Box display='flex' alignItems='center' flexDir='column' gap='0.5rem'>
                                  <Box w="5rem" h="5rem">
                                    <Image
                                      w="100%"
                                      h="100%"
                                      borderRadius="full"
                                      src={patienData.patientinfo.patientimage ?
                                        (patienData.patientinfo.patientimage.startsWith('https') ? patienData.patientinfo.patientimage : patienData.patientinfo.imagepath + patienData.patientinfo.patientimage)
                                        : '/assets/imgs/no-image.png'}

                                    />
                                  </Box>
                                  <Box display='flex' flexDir='column' alignItems='center' gap='0.25rem'>
                                    <Text fontSize="1rem" fontWeight="600">
                                      {`${patienData.patientinfo.firstname}  ${patienData.patientinfo.lastname}`}
                                    </Text>
                                    <Text fontSize="0.75rem" fontWeight="400" color="#384052">
                                      {`#${patienData.patientinfo.uniqueid}`}
                                    </Text>
                                  </Box>
                                  <Flex flexDir='column' w='100%' gap='8px'>
                                    <Box display="flex" alignItems="center">
                                      <Image src="/assets/svgs/gender.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="10px">
                                        {
                                          patienData.patientinfo.gender
                                            ? patienData.patientinfo.gender.charAt(0).toUpperCase() +
                                            (patienData.patientinfo.gender.length > 1 ? patienData.patientinfo.gender.slice(1).toLowerCase() : 'N/A')
                                            : '-'
                                        }
                                      </Text>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Image ml='4px' src="/assets/svgs/height.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="1rem">
                                        {patienData.patientinfo.height ? (patienData.patientinfo.height + " " + patienData.patientinfo.heightunit) : ('N/A')}
                                      </Text>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Image src="/assets/svgs/weight.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="10px">
                                        {patienData.patientinfo.weight ? (patienData.patientinfo.weight + " " + patienData.patientinfo.weightunit) : ('N/A')}
                                      </Text>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Image ml='2px' src="/assets/svgs/phone-number.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="12px">
                                        {patienData &&
                                          patienData.patientinfo &&
                                          patienData.patientinfo.mobileno
                                          ? (`${patienData.patientinfo.countrycode} ${"  "}${patienData.patientinfo.mobileno}`)
                                          : "N/A"}
                                      </Text>
                                    </Box>
                                    <Box display="flex" alignItems="center">
                                      <Image src="/assets/svgs/email.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                        {patienData.patientinfo.email ? patienData.patientinfo.email : "N/A"}
                                      </Text>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Image src="/assets/svgs/cake.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                        {patienData &&
                                          patienData.patientinfo &&
                                          patienData.patientinfo.dob
                                          ? (`${patienData.patientinfo.dob} ${calculateAgeCommonFunc(patienData.patientinfo.dobDbFormat)}`)
                                          : "N/A"}
                                      </Text>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Image src="/assets/svgs/calendar-filled.svg" />

                                      <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                        {patienData.patientinfo.nextappointmentdate && patienData.patientinfo.nextappointmenttime && patienData.patientinfo.nextappointmentstatus ? (
                                          `${patienData.patientinfo.nextappointmentstatus}: ${formatDate(patienData.patientinfo.nextappointmentdate)} at ${formatTime(patienData.patientinfo.nextappointmenttime)}`
                                        ) : (
                                          "Not Scheduled"
                                        )}
                                      </Text>
                                    </Box>

                                    <Divider/>

                                    <Box display="flex" bg='white' border="1px solid #E6E7E9" p="0.5rem" borderRadius="10px" flexDir='column' alignItems="center" justifyContent="center" w="100%" mt="0.5rem">
                                      <Text fontSize="0.875rem" fontWeight="600">
                                        Consulting Doctor:
                                      </Text>
                                      <Text fontSize="0.875rem" color='#1C4EC5' fontWeight="500">
                                        {patienData.patientinfo.doctorassignedname ? patienData.patientinfo.doctorassignedname : "N/A"}
                                      </Text>
                                    </Box>
                                   
                                    <Box display="flex" bg='white' border="1px solid #E6E7E9" p="0.5rem" borderRadius="10px" flexDir='column' alignItems="center" justifyContent="center" w="100%" mt="0.5rem">
                                      <Text fontSize="0.875rem" fontWeight="600">
                                        Admitted Date:
                                      </Text>
                                      <Text fontSize="0.875rem" color='#1C4EC5' fontWeight="500">
                                        {patienData?.patientinfo?.admindate ? formatDate(patienData.patientinfo.admindate) : "N/A"}
                                      </Text>
                                    </Box>

                                    <Box mt='0.5rem' border="1px solid #E6E7E9" borderRadius="10px" p="0.5rem" w="100%">
                                      <Text textAlign='center' fontSize="0.875rem" fontWeight="500">
                                        HMS ID: {patienData?.patientinfo?.hmsuniqueid ? patienData.patientinfo.hmsuniqueid : "N/A"}
                                      </Text>
                                    </Box>

                                  {/* {patienData?.patientinfo?.dischargedate && (
                                    <PrimaryButton
                                      variant="deleteBtn"
                                      btnStyle={{h:'40px', mt:'1rem'}}
                                      buttonText="Discharge"
                                      onClick={redirectDischargeSummary}
                                    />
                                  )} */}
                                  {patienData?.patientinfo?.dischargedate !== null ? (
  // <Box 
  //   display="flex" 
  //   alignItems="center" 
  //   justifyContent="center"
  //   h="40px" 
  //   mt="1rem"
  //   border="1px solid green"
  //   borderRadius="8px"
  //   bg="green.50"
  //   color="green.700"
  //   fontWeight="medium"
  // >
  //   Discharged
  // </Box>
  // <Box mt='0.5rem' border="1px solid #E6E7E9" borderRadius="10px" p="0.5rem" w="100%" bg="green.50"
  // color="green.700" >
  //   <Text textAlign='center' fontSize="0.875rem" fontWeight="500">
  //     Discharged
  //   </Text>
  // </Box>
  <>
    <Box display="flex" bg='white' border="1px solid #E6E7E9" p="0.5rem" borderRadius="10px" flexDir='column' alignItems="center" justifyContent="center" w="100%" mt="0.5rem">
      <Text fontSize="0.875rem" fontWeight="600">
        Discharge Date:
      </Text>
      <Text fontSize="0.875rem" color='#1C4EC5' fontWeight="500">
        {patienData?.patientinfo?.dischargedate ? formatDate(patienData.patientinfo.dischargedate) : "N/A"}
      </Text>
    </Box>
    <PrimaryButton variant='deleteBtn' isDisabled btnStyle={{w:'100%', mt: '0.75rem'}} buttonText='Discharged'/> 
  </>
) : (
  <PrimaryButton
    variant="deleteBtn"
    btnStyle={{h:'40px', mt:'1rem'}}
    buttonText="Discharge"
    onClick={redirectDischargeSummary}
  />
)}
                                  </Flex>
                                </Box>
                              </Box>
                            </Box>
                            {/* <Stack direction="column" gap="0.75rem" w="100%">

                              <Box display="flex" alignItems="center" pr="20px" mt="15px"
                                opacity={actionAccessPatients?.create ? 1 : 0.5}>

                                <input
                                  type="file"
                                  id="genericupload"
                                  style={{ display: 'none' }}
                                  accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf" // Specify accepted file types
                                  onChange={GenericUpload}
                                  multiple
                                />
                                <PrimaryInput
                                  inputType="file"
                                  uploadText="Upload document"
                                  id="genericupload"
                                  docBtnWidth="195px"
                                  docBtnColor="#1C4EC5"
                                  iconImg="/assets/svgs/prescriptions.svg"
                                  iconImgCss={{
                                    width: "30px", height: "auto", color: "#1C4EC5",
                                    filter: "brightness(0) saturate(100%) invert(24%) sepia(84%) saturate(2247%) hue-rotate(215deg) brightness(83%) contrast(96%)"
                                  }}
                                  onChange={GenericUpload}
                                  variant="grayBtnFull"
                                  disableFileInput={actionAccessPatients?.create ? false : true}
                                />

                              </Box>

                              <Box>
                                <PrimaryButton
                                  buttonText="Add Vitals"
                                  variant="grayBtn"
                                  btnStyle={{ w: "80%" }}
                                  w='100%'
                                />

                              </Box>

                            </Stack> */}
                          </VStack>
                        ) : (
                          <VStack p="1.5rem" align="stretch" gap="1rem" overflow="hidden auto" bg="#fcfcfd" h="100vh">
                            <Box>
                              <Box display="flex" flexDir="column" gap="0.65rem">
                                <Box display='flex' alignItems='center' gap='1rem'>
                                  <Box w="5rem" h="5rem">
                                    <Image
                                      w="100%"
                                      h="100%"
                                      borderRadius="full"
                                      // src={
                                      //     patienData.patientinfo.patientimage? 
                                      //     (`${patienData.patientinfo.imagepath}${patienData.patientinfo.patientimage}`) : ("/assets/imgs/no-image.png")
                                      // }
                                      src={patienData.patientinfo.patientimage ?
                                        (patienData.patientinfo.patientimage.startsWith('https') ? patienData.patientinfo.patientimage : patienData.patientinfo.imagepath + patienData.patientinfo.patientimage)
                                        : '/assets/imgs/no-image.png'}

                                    />
                                  </Box>

                                  <Flex flexDir='column' gap='3px'>
                                    <Box display="flex" alignItems="center">
                                      <Image src="/assets/svgs/gender.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="10px">
                                        {/* Male */}
                                        {/* {patienData.patientinfo.gender ? patienData.patientinfo.gender : ('-')} */}

                                        {
                                          patienData.patientinfo.gender
                                            ? patienData.patientinfo.gender.charAt(0).toUpperCase() +
                                            (patienData.patientinfo.gender.length > 1 ? patienData.patientinfo.gender.slice(1).toLowerCase() : '')
                                            : '-'
                                        }
                                      </Text>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Image ml='4px' src="/assets/svgs/height.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="1rem">
                                        {/* 6ft 3in */}
                                        {patienData.patientinfo.height ? (patienData.patientinfo.height + " " + patienData.patientinfo.heightunit) : ('0')}
                                      </Text>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Image src="/assets/svgs/weight.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="10px">
                                        {/* 75 kg */}
                                        {/* {patienData.patientinfo.weight + " " + patienData.patientinfo.weightunit } */}
                                        {patienData.patientinfo.weight ? (patienData.patientinfo.weight + " " + patienData.patientinfo.weightunit) : ('0')}
                                      </Text>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Image ml='2px' src="/assets/svgs/phone-number.svg" />
                                      <Text fontSize="0.875rem" fontWeight="500" ml="12px">
                                        {/* +1 (647) 523-9797 */}
                                        {/* {`${patienData.patientinfo.countrycode} ${patienData.patientinfo.mobileno}`} */}
                                        {patienData &&
                                          patienData.patientinfo &&
                                          patienData.patientinfo.mobileno
                                          ? (`${patienData.patientinfo.countrycode} ${"  "}${patienData.patientinfo.mobileno}`)
                                          : "-"}
                                      </Text>
                                    </Box>
                                  </Flex>

                                </Box>
                                <Box display="flex" flexDir="column">
                                  <Text fontSize="1rem" fontWeight="600">
                                    {`${patienData.patientinfo.firstname}  ${patienData.patientinfo.lastname}`}
                                  </Text>
                                  <Box display="flex" gap="0.5rem">
                                    {/* <Image src="/assets/svgs/calendar-filled.svg" /> */}
                                    <Image src="/assets/svgs/name.svg" />
                                    <Text fontSize="0.75rem" fontWeight="400" color="#384052">
                                      {/* Upcoming: 10th Jan, 2024 at 9:30 AM */}
                                      {`#${patienData.patientinfo.uniqueid}`}

                                      {/* {patienData.patientinfo.nextappointmentstatus !== 'Cancelled' ? (patienData.patientinfo.nextappointmentdate && patienData.patientinfo.nextappointmenttime && (
                                              `Upcoming: ${formatDate(patienData.patientinfo.nextappointmentdate)} at ${formatTime(patienData.patientinfo.nextappointmenttime)}`
                                              )) : (
                                                "-"
                                              )} */}

                                      {/* {`${formatDate(patienData.patientinfo.lastupdatedate)} at ${formatDateAndTime(patienData.patientinfo.lastupdatedate)}`} */}
                                    </Text>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                            <Divider />
                            <Stack direction="column" gap="0.75rem" w="100%">
                              {/* <Box display="flex" alignItems="center">
                                <Image src="/assets/svgs/name.svg" />
                                <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                    {`${patienData.patientinfo.firstname}  ${patienData.patientinfo.lastname}`}
                                </Text>
                                </Box> */}

                              <Box display="flex" alignItems="center">
                                <Image src="/assets/svgs/email.svg" />
                                <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                  {/* adnan@supastellar.co */}
                                  {patienData.patientinfo.email}
                                </Text>
                              </Box>





                              <Box display="flex" alignItems="center">
                                <Image src="/assets/svgs/cake.svg" />
                                <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                  {/* 29 August, 1997 */}
                                  {/* {patienData.patientinfo.dob} */}
                                  {patienData &&
                                    patienData.patientinfo &&
                                    patienData.patientinfo.dob
                                    ? (`${patienData.patientinfo.dob} ${calculateAgeCommonFunc(patienData.patientinfo.dobDbFormat)}`)
                                    : "-"}
                                </Text>
                              </Box>

                              <Box display="flex" alignItems="center">
                                {/* <Image src="/assets/svgs/name.svg" />
                                 */}
                                <Image src="/assets/svgs/calendar-filled.svg" />

                                <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                  {/* {`${patienData.patientinfo.uniqueid}`} */}
                                  {patienData.patientinfo.nextappointmentdate && patienData.patientinfo.nextappointmenttime && patienData.patientinfo.nextappointmentstatus ? (
                                    `${patienData.patientinfo.nextappointmentstatus}: ${formatDate(patienData.patientinfo.nextappointmentdate)} at ${formatTime(patienData.patientinfo.nextappointmenttime)}`
                                  ) : (
                                    "Upcoming:"
                                  )}
                                </Text>
                              </Box>

                              <Box display="flex" alignItems="center" pr="20px" mt="15px"
                                opacity={actionAccessPatients?.create ? 1 : 0.5}>

                                <input
                                  type="file"
                                  id="genericupload"
                                  style={{ display: 'none' }}
                                  accept="image/jpeg,image/jpg,image/png,image/tiff,application/pdf" // Specify accepted file types
                                  onChange={GenericUpload}
                                  multiple
                                />
                                <PrimaryInput
                                  inputType="file"
                                  uploadText="Upload document"
                                  id="genericupload"
                                  docBtnWidth="195px"
                                  docBtnColor="#1C4EC5"
                                  iconImg="/assets/svgs/prescriptions.svg"
                                  iconImgCss={{
                                    width: "30px", height: "auto", color: "#1C4EC5",
                                    filter: "brightness(0) saturate(100%) invert(24%) sepia(84%) saturate(2247%) hue-rotate(215deg) brightness(83%) contrast(96%)"
                                  }}
                                  onChange={GenericUpload}
                                  variant="grayBtnFull"
                                  disableFileInput={actionAccessPatients?.create ? false : true}
                                />

                              </Box>

                              <Box>
                                <PrimaryButton
                                  buttonText="Add Vitals"
                                  // onClick={() => addVitalData.current.openRight()}
                                  onClick={openVitalsModal}
                                  variant="grayBtn"
                                  btnStyle={{ w: "80%" }}
                                  w='100%'
                                />
                                {/* <PrimaryButton
                    fontSize="14px"
                    variant="mdBtn"
                    buttonText="Add data"
                    btnIcon="/assets/imgs/add.png"
                    onClick={() => adddata.current.openRight()}
                  /> */}

                              </Box>

                            </Stack>
                          </VStack>

                        )
                      )
                      // : ("No records found")
                    }
                  </Box>

                  {/* Recent Activity end */}
                  {/* Right area end */}
                </Box>
              </Flex>
              {/* Main container end */}
            </Box>
          </Flex>
        </Box>
      ) : (
        <>

          {/* Mobile responsive */}
          <Box w="100%">
            {activeSection == null && (
              <>
                <MobileSecondaryNav
                  header="Patient profile"
                  handlebackarrow={() => navigate('/messages')}
                />
                <Box w="100%" h="calc(100vh - 120px)" overflow="hidden auto">
                  {/* Patient details start */}
                  <Box w="100%" borderLeft="1px solid #E6E7E9">
                    {
                      patienData && patienData.patientinfo && (

                        <VStack p="1.5rem" align="stretch" gap="1rem" bg="white">
                          <Box>
                            <Box display="flex" flexDir="column" gap="0.65rem">
                              <Box w="5rem" h="5rem">
                                <Image
                                  w="100%"
                                  h="100%"
                                  borderRadius="full"
                                  src={
                                    patienData.patientinfo.patientimage ?
                                      (`${patienData.patientinfo.imagepath}${patienData.patientinfo.patientimage}`) : ("/assets/imgs/no-image.png")
                                  }

                                />
                              </Box>
                              <Box display="flex" flexDir="column">
                                <Text fontSize="1rem" fontWeight="600">
                                  {/* Dr. Samantha Raulf */}
                                  {`${patienData.patientinfo.firstname}  ${patienData.patientinfo.lastname}`}
                                </Text>
                                <Box display="flex" gap="0.5rem">
                                  <Image src="/assets/svgs/calendar-filled.svg" />
                                  <Text fontSize="0.75rem" fontWeight="400" color="#384052">
                                    {/* Upcoming: 10th Jan, 2024 at 9:30 AM */}

                                    {patienData.patientinfo.nextappointmentdate && patienData.patientinfo.nextappointmenttime ? (
                                      `Upcoming: ${formatDate(patienData.patientinfo.nextappointmentdate)} at ${formatTime(patienData.patientinfo.nextappointmenttime)}`
                                    ) : (
                                      "-"
                                    )}

                                    {/* {`${formatDate(patienData.patientinfo.lastupdatedate)} at ${formatDateAndTime(patienData.patientinfo.lastupdatedate)}`} */}
                                  </Text>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                          <Divider />
                          <Stack direction="column" gap="0.75rem" w="100%">
                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/name.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                {/* Adnan Jaweed */}
                                {`${patienData.patientinfo.firstname}  ${patienData.patientinfo.lastname}`}
                              </Text>
                            </Box>

                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/email.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                {/* adnan@supastellar.co */}
                                {patienData.patientinfo.email}
                              </Text>
                            </Box>

                            <Box display="flex" alignItems="center">
                              <Image src="/assets/svgs/phone-number.svg" />
                              <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                {/* +1 (647) 523-9797 */}
                                {`${patienData.patientinfo.countrycode} ${patienData.patientinfo.mobileno}`}
                              </Text>
                            </Box>

                            <Box display="flex" w="100%" justifyContent="space-between" alignItems="center">
                              <Box display="flex" w="50%">
                                <Image src="/assets/svgs/gender.svg" />
                                <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                  {patienData.patientinfo.gender}
                                </Text>
                              </Box>

                              <Box display="flex" w="50%">
                                <Image src="/assets/svgs/height.svg" />
                                <Text fontSize="0.875rem" fontWeight="500" ml="1rem">
                                  {patienData.patientinfo.height ? (patienData.patientinfo.height + " " + patienData.patientinfo.heightunit) : ('0')}
                                </Text>
                              </Box>
                            </Box>

                            <Box display="flex" w="100%" justifyContent="space-between" alignItems="center">
                              <Box display="flex" w="50%">
                                <Image src="/assets/svgs/weight.svg" />
                                <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                  {patienData.patientinfo.weight ? (patienData.patientinfo.weight + " " + patienData.patientinfo.weightunit) : ('0')}
                                </Text>
                              </Box>

                              <Box display="flex" w="50%">
                                <Image src="/assets/svgs/cake.svg" />
                                <Text fontSize="0.875rem" fontWeight="500" ml="0.5rem">
                                  {patienData.patientinfo.dob}
                                </Text>
                              </Box>

                            </Box>

                          </Stack>
                        </VStack>
                      )
                      // : ("No records found")
                    }
                  </Box>
                  {/* Patient details end */}
                  <Divider />
                  {/* Menu section start */}
                  <Box p="1.5rem" bg="white">
                    <Box w="100%">
                      <SimpleGrid columns={{ base: 4, sm: 6 }} spacing="1rem">
                        {navItems.map((item, index) => (
                          <Box key={index} zIndex="3" display="flex" justifyContent="center" alignItems="center" textAlign='center' flexDir='column' gap="0.5rem">
                            <Box as="button" boxSize="4rem" onClick={() => setActiveSection(item.to)} borderRadius="8px" bg="#F9FAFB" border="1px solid #0B1F4F4D" display="flex" justifyContent="center" alignItems="center">
                              <Image src={item.iconSrc} alt={item.text} />
                            </Box>
                            <Text fontSize="0.75rem" letterSpacing="-0.05rem" whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden" wordBreak="" w="-webkit-fill-available">{item.text}</Text>
                          </Box>
                        ))}
                      </SimpleGrid>
                    </Box>
                  </Box>
                  {/* Menu section end */}

                  <Divider />

                  {/* <Box w="100%">
            <Flex w="100%" flexDir='column'>
            {navItems.map((item, index)=> (
              <Box key={index} w="100%" p="1rem" display='flex' borderBottom='1px solid #e2e8f0' gap='1rem' alignItems='center'>
                <Image src={item.iconSrc} />
                <Text>{item.text}</Text>
                <Spacer />
                <Image src="/assets/imgs/right-icon.png" />
              </Box>
              ))}
            </Flex>
          </Box> */}


                </Box>
              </>
            )}
            <Flex>
              {activeSection && activeSection == "overview" && (
                <OverviewIndex pid={patientId} backFunction={backFunction} />
              )}
              {activeSection == "visits" && (
                <PatientVisitsIndex id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "chiefComplaint" && (
                <ChiefComplaint id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "historyOfPresentIllness" && (
                <HistoryOfPresentIllness id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "orders" && (
                <OrdersIndex id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "vitals" && (
                <PatientVitalsIndex id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "medicalHistory" && (
                <MedicalHistory id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "surgicalHistory" && (
                <SurgicalHistory id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "familyHistory" && (
                <FamilyHistory id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "socialHistory" && (
                <SocialHistory id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "physicalExam" && (
                <PhysicalExam id={patientId} backFunction={backFunction} />
              )}

              {/* {activeSection == "treatmentPlan" && (
                  <TreatmentPlan id={patientId} backFunction={backFunction} />
                )} */}
              {activeSection == "doctorAssessment" && (
                <DoctorAssessment id={patientId} backFunction={backFunction} />
              )}

              {activeSection == "reviewSystem" && (
                <ReviewSystem id={patientId} backFunction={backFunction} />
              )}
              {activeSection == "allergies" && (
                <Allergies id={patientId} backFunction={backFunction} />
              )}
              {activeSection == "vaccinations" && (
                <Vaccinations id={patientId} backFunction={backFunction} />
              )}
              {activeSection == "investigations" && (
                <Investigations id={patientId} backFunction={backFunction} />
              )}
              {activeSection == "labTest" && (
                <LabTests id={patientId} backFunction={backFunction} />
              )}
              {activeSection == "imaging" && (
                <Imaging id={patientId} backFunction={backFunction} />
              )}

            </Flex>
          </Box>
        </>
      )}

      <ModalRight
        ref={addVitalData}
        header="Add Vitals"
        bodyStyle={{ p: "24px 32px" }}
        modalWidth="calc(100vw - 50%)"
        body={
          <>
            <Box display="flex" flexDir="column" gap="20px">
              <VStack spacing={4} align="stretch" height="100%">
                {/* Row 1 */}

                <Flex direction="row" gap='1rem' align="center" width="100%">
                  <Flex direction="column" width="100%">
                    <FormLabel mb="0" width={{ base: "20%", md: "100%" }}>
                      Body Temperature ({tempUnit})
                    </FormLabel>
                    <Flex direction="column" width="100%">
                      <Flex align="center" mb={1} gap={2} >
                        {/* <Box fontSize="xs" fontWeight="bold">
                        {tempUnit}
                      </Box> */}

                      <Select
                        value={tempUnit}
                        onChange={(e) => handleTempUnitChange(e.target.value)}
                        fontSize={"xs"}
                        size={"xs"}
                        width='max-content'
                        bg='white'
                        pl='0'
                        className="tempUnit"
                        borderRadius='8px'
                      >
                        <option value="°F">°F</option>
                        <option value="°C">°C</option>
                      </Select>

                        {/* <Select
                          // value={weightUnit === "lbs" ? "Standard" : "Metric"}
                          value={tempUnit === "°F" ? "°F" : "°C"}
                          onChange={(e) => handleTempUnitChange(e.target.value)}
                          fontSize={"xs"}
                          size={"xs"}
                          width='max-content'
                          // border="none"
                          textAlignLast="left"
                          bg='white'
                          pl='0'
                          className="tempUnit"
                          borderRadius='8px'
                        >
                          <option value="°F">°F</option>
                          <option value="°C">°C</option>
                        </Select> */}
                      </Flex>
                    </Flex>
                  </Flex>

                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace={`Enter value (${tempUnit === "°F" ? `${MIN_TEMP_F}-${MAX_TEMP_F}°F` : `${MIN_TEMP_C.toFixed(1)}-${MAX_TEMP_C.toFixed(1)}°C`})`}
                    id="bodyTemperature"
                    onChange={handleChangeBodyTemperature}
                    inputValue={tempValue}
                    maxLength={5}
                  />

                  {/* <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleChangeBodyTemperature}
                    inputValue={tempValue}
                    maxLength={5}
                  /> */}

                  <Flex direction="column" width={{ base: "50%", md: "100%" }}>
                    <FormLabel width={{ base: "100%", md: "100%" }} mb="0px">
                      Heart Rate
                    </FormLabel>
                    <Box fontSize={"xs"} pt="2px">
                      beats per minute
                    </Box>
                  </Flex>


                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleChangeHeartRate}
                    inputValue={heartRate}
                    maxLength={3}
                  />
                </Flex>
                <Divider />
                {/* Row 2 */}
                <Flex height="60px" gap='1rem' align="center">
                  <Flex direction="column" width="100%">
                    <FormLabel width={{ base: "100%", md: "100%" }} mb="0px">
                      Respiratory Rate
                    </FormLabel>
                    <Box fontSize={"xs"} pt="2px">
                      breaths per minute
                    </Box>
                  </Flex>
                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleChangeRespiratoryRate}
                    inputValue={respRate}
                    maxLength={3}
                  />

                  {/* Single Label for both Systolic and Diastolic */}
                  <Flex direction="column" width="100%">
                    <FormLabel mb="0px">Blood Pressure</FormLabel>
                    <Box fontSize={"xs"} pt="2px">
                      mmHg
                    </Box>
                  </Flex>

                  {/* Systolic and Diastolic Input Fields Aligned Right */}
                  <Box width="100%" textAlign="right">
                    <Flex justify="flex-end" align="center">
                      {/* Systolic Input */}

                      <PrimaryInput
                        variant="fullRound"
                        title="Search by name"
                        inputPlace="Systolic"
                        id="yourName"
                        onChange={handleChangeSystolic}
                        inputValue={systolic}
                        maxLength={3}
                      />

                      <Box mx={2}>/</Box>

                      {/* Diastolic Input */}
                      <PrimaryInput
                        variant="fullRound"
                        title="Search by name"
                        inputPlace="Distolic"
                        id="yourName"
                        onChange={handleChangeDistolic}
                        inputValue={distolic}
                        maxLength={3}
                      />

                    </Flex>
                  </Box>
                </Flex>
                <Divider />
                <Flex height="60px" w='50%' align="center">
                  <Flex direction="column" width="100%">
                    <FormLabel width="30%" mb="0px">
                      SPO2
                    </FormLabel>
                    <Box fontSize={"xs"} pt="2px">
                      %
                    </Box>
                  </Flex>

                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleSP02}
                    inputValue={spo2}
                    maxLength={3}
                  />
                </Flex>
                <Divider />

                {/* Row 6 */}
                <Flex height="60px" gap='1rem' align="center">

                  <Flex direction="column" width="100%">
                    <FormLabel width="100%" mb="0px">
                      Fasting Blood Glucose
                    </FormLabel>
                    <Box fontSize={"xs"} pt="2px">
                      mg/dL
                    </Box>
                  </Flex>
                  <PrimaryInput
                    variant="fullRound"
                    title="Search by name"
                    inputPlace="Enter value"
                    id="yourName"
                    onChange={handleFastingBloodGlucose}
                    inputValue={fastingBloodGlucose}
                    maxLength={3}
                  />

                  <Flex direction="column" width="100%">
                    <FormLabel width="60%" mb="0px">
                      Postprandial Blood Glucose
                    </FormLabel>
                    <Box fontSize={"xs"} pt="2px">
                      mg/dL
                    </Box>
                  </Flex>
                  <Box width="100%" textAlign="right">

                    <PrimaryInput
                      variant="fullRound"
                      title="Search by name"
                      inputPlace="Enter value"
                      id="yourName"
                      onChange={handlePostBloodGlucose}
                      inputValue={postBloodGlucose}
                      maxLength={3}
                    />
                  </Box>

                </Flex>

                <Divider />
                {/* Weight */}
                <Flex direction="row" gap='1rem' align="center" width="100%" >
                  <Flex direction="column" width="100%">
                    <FormLabel mb="0" width={{ base: "20%", md: "100%" }}>
                      {/* Weight ({weightUnit}) */}
                      Weight ({weightUnit === 'Standard' ? 'lbs' : 'Kg'})
                    </FormLabel>
                    <Flex direction="column" width="100%">
                      <Flex align="center" mb={1} gap={2} >
                        {/* <Box fontSize="xs" fontWeight="bold">
                          {weightUnit}
                        </Box> */}
                        <Select
                          value={weightUnit} // or heightUnit for the height select
                          onChange={(e) => handleUnitChange(e.target.value)}
                          fontSize={"xs"}
                          size={"xs"}
                          bg='white'
                          width={{ base: "80px", md: "90px" }}
                          textAlignLast="left"
                          borderRadius='8px'
                        >
                          <option value="Standard">Standard</option>
                          <option value="Metric">Metric</option>
                        </Select>
                        {/* <Select
                          value={weightUnit === "lbs" ? "Standard" : "Metric"}
                          onChange={(e) => handleUnitChange(e.target.value)}
                          fontSize={"xs"}
                          size={"xs"}
                          bg='white'
                          width={{ base: "80px", md: "90px" }}
                          // border="none"
                          textAlignLast="left"
                          borderRadius='8px'
                          className='weightUnit'
                        >
                          <option value="Standard">Standard</option>
                          <option value="Metric">Metric</option>
                        </Select> */}
                      </Flex>
                    </Flex>
                  </Flex>
                  <Box w="100%" textAlign="right">
                    <Input
                      type="number"
                      value={weightValue}
                      placeholder={weightUnit === 'Standard' ? 'lbs' : 'kg'}
                      onChange={(e) => setWeightValue(e.target.value)}
                      height="48px"
                      width='100%'
                      p="0 10px"
                      bg={"white"}
                      textAlign={"center"}
                      ml="auto"
                    />
                    {/* <Input
                      type="number"
                      value={weightValue}
                      // placeholder={weightUnit}
                      placeholder={weightUnit === 'Standard' ? 'lbs' : 'kg'}
                      onChange={(e) => setWeightValue(e.target.value)}
                      // height="40px"
                      // p="0 10px"
                      // width={{ base: "100px", md: "150px" }}
                      height="48px"
                      width='100%'
                      p="0 10px"
                      bg={"white"}
                      textAlign={"center"}
                      ml="auto"
                    /> */}
                  </Box>

                  <Flex direction="column" width="100%">
                    <FormLabel mb="0" width={{ base: "20%", md: "100%" }}>
                      {/* Height ({heightUnit}) */}
                      Height ({heightUnit === 'Standard' ? 'ft' : 'cms'})
                    </FormLabel>
                    <Flex direction="column" width="100%">
                      <Flex align="center" mb={1} gap={2} >
                        {/* <Box fontSize="xs" fontWeight="bold">
                          {heightUnit}
                        </Box> */}
                        <Select
                          // value={heightUnit === "ft" ? "Standard" : "Metric"}
                          value={heightUnit}
                          onChange={(e) => handleUnitChange(e.target.value)}
                          // defaultValue={heightUnit}
                          fontSize={"xs"}
                          size={"xs"}
                          bg='white'
                          width={{ base: "80px", md: "90px" }}
                          // border="none"
                          textAlignLast="left"
                          borderRadius='8px'
                          className="heightUnit"
                        >
                          <option value="Standard">Standard</option>
                          <option value="Metric">Metric</option>
                        </Select>
                      </Flex>
                    </Flex>
                  </Flex>
                  <Flex justify="flex-end" w='100%' align="center" gap={2}>
                    <Input
                      type="number"
                      value={heightValue}
                      placeholder={heightUnit === 'Standard' ? 'ft' : 'cms'}
                      //     onChange={(e) => {
                      //   const value = e.target.value;
                      //   // Prevent decimal input in feet when in Standard mode
                      //   if (heightUnit === 'Standard' && value.includes('.')) {
                      //     return;
                      //   }
                      //   setHeightValue(value);
                      // }}
                      onChange={(e) => {
                        const value = e.target.value;
                        // For Standard units, only allow whole numbers
                        if (heightUnit === 'Standard') {
                          // if (value.includes('.') || isNaN(parseInt(value))) {
                          //   return;
                          // }
                          // setHeightValue(value ? parseInt(value).toString() : '');
                          if (value.includes('.') || isNaN(parseInt(value))) return;
                          setHeightValue(value ? parseInt(value).toString() : '');
                        } else {
                          // For Metric units, allow decimals
                          setHeightValue(value);
                        }
                      }}
                      // onChange={(e) => setHeightValue(e.target.value)}
                      height="48px"
                      p="0 10px"
                      width={heightUnit === 'Standard' ? '50%' : '100%'}
                      bg={"white"}
                      textAlign={"center"}
                    />
                    {heightUnit === 'Standard' && (
                      <>
                        <Box>.</Box>
                        <Input
                          type="number"
                          value={heightSubValue}
                          placeholder="in"
                          // onChange={(e) => setHeightSubValue(e.target.value)}
                          //   onChange={(e) => {
                          //   const value = e.target.value;
                          //   // Only allow whole numbers between 0-11
                          //   // if (isNaN(parseInt(value)) || parseInt(value) < 0 || parseInt(value) > 11) {
                          //   //   return;
                          //   // }
                          //   // setHeightSubValue(value ? parseInt(value).toString() : '');
                          //   if (value && (isNaN(parseInt(value)) || parseInt(value) < 0 || parseInt(value) > 11)) return;
                          //   setHeightSubValue(value);

                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow empty but validate on submit
                            if (value === '') {
                              setHeightSubValue('');
                              return;
                            }
                            // Validate number if entered
                            if (isNaN(parseInt(value)) || parseInt(value) < 0 || parseInt(value) > 11) return;
                            setHeightSubValue(parseInt(value).toString());
                          }}
                          //         onChange={(e) => {
                          //   const value = e.target.value;
                          //   // Limit inches to 11 (0-11)
                          //   if (parseInt(value) > 11) {
                          //     return;
                          //   }
                          //   setHeightSubValue(value);
                          // }}
                          height="48px"
                          p="0 10px"
                          width='50%'
                          bg={"white"}
                          textAlign={"center"}
                        />
                      </>
                    )}
                    {/* <Input
                      type="number"
                      value={heightValue}
                      defaultValue={heightValue}
                      // placeholder={heightUnit}
                      placeholder={heightUnit === 'Standard' ? 'ft' : 'cm'}
                      onChange={(e) => setHeightValue(e.target.value)}
                      height="48px"
                      p="0 10px"
                      width='50%'
                      bg={"white"}
                      textAlign={"center"}
                    />
                    {heightUnit === 'Standard' && (
                      <>
                    <Box>.</Box>
                    <Input
                      type="number"
                      value={heightSubValue}
                      // placeholder={heightUnit === "ft" ? "in" : "mm"}
                      // placeholder={heightUnit === 'Standard' ? 'in' : 'mm'}
                      placeholder="in"
                      onChange={(e) => setHeightSubValue(e.target.value)}
                      height="48px"
                      p="0 10px"
                      width='50%'
                      bg={"white"}
                      textAlign={"center"}
                    />
                    </>
                    )} */}
                  </Flex>
                </Flex>

                <Flex direction="row" align="center" pr='1rem' justifyContent='center' width="100%" >
                  <Box w="100%" textAlign="right">
                    <Text fontSize='0.875rem' fontWeight='600'>BMI (Calculated): {bmi || '0'} </Text>
                    {/* <Text fontSize='0.875rem' fontWeight='600'>BMI (calculated): {calculatedBMI || 0}</Text> */}
                    {/* <Text fontSize='0.875rem' fontWeight='600'>{calculatedBMI || 0}</Text> */}
                  </Box>
                </Flex>

                <Divider />
                {/* <Flex height="60px" w='50%' align="center">
                  <Flex direction="column" width="100%">
                    <FormLabel width="30%" mb="0px">
                      SPO2
                    </FormLabel>
                    <Box fontSize={"xs"} pt="2px">
                      %
                    </Box>
                  </Flex>

                    <PrimaryInput
                      variant="fullRound"
                      title="Search by name"
                      inputPlace="Enter value"
                      id="yourName"
                      onChange={handleSP02}
                      inputValue={spo2}
                      maxLength={3}
                    />
                </Flex> */}
              </VStack>
            </Box>
          </>
        }
        footerActions={
          <>
            <Box w="100%" display="flex" flexDirection="row" gap="15px">
              {/* <PrimaryButton
                  buttonText="Add Vitals"
                  // onClick={addmedicine}
                  isDisabled={false}
                /> */}

              <PrimaryButton
                type="submit"
                onClick={() => {
                  SubmitBMIform();
                }}
                buttonText="Save Vitals"
                isDisabled={
                  //(isButtonDisabled && !heightValue && !weightValue) ||
                  !actionAccessMain(19)?.create
                }
              />
            </Box>
          </>
        }
      />
    </>
  )
}

export default PatientProfileIndex